import React from 'react';
import { Checkbox, Field } from '../../../../../../Core';
import { ListFieldSection } from '../../../../../../Layout';
import { withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';

let ResultsReportOptionsSection: React.FC<IWorksheetComponent> = () => (
  <ListFieldSection heading="Report" single>
    <Field input={<Checkbox />} label="Fineness Modulus" name="Results.ReportFinenessModulus" />
  </ListFieldSection>
);

ResultsReportOptionsSection = withInjectedProps(ResultsReportOptionsSection);

export { ResultsReportOptionsSection };
export default ResultsReportOptionsSection;
